import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'
class VendorService extends CrudService {
  constructor() {
    super(API_RESOURCE.VENDOR)
  }

  uploadVendor = async (file) => {
    const form = new FormData()
    form.append('file', file)

    const response = await axios.post(`${this.resource}/upload`, form)

    return response.data
  }

  registerTempVendor = async (data) => {
    const response = await axios.post(`${this.resource}/registerTemp`, data)

    return response.data
  }

  requestCreateTempVendor = async (data) => {
    const response = await axios.post(`${this.resource}/requestTemp`, data)

    return response.data
  }
}

export default VendorService
